/**
 * Temporary product switches. Flip to true to bring a feature back.
 * Catalog gate also has a matching switch in backend catalogGateService.
 */
export const WALLET_ENABLED = false;
export const CATALOG_GATE_ENABLED = false;
